import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SignedOut, SignedIn, UserButton, useAuth } from "@clerk/clerk-react";
import { useApi } from "api";

import { StyledLoginButton, StyledSignUpButton, StyledAuthButtons } from "./styled";

const AuthContainer: React.FC = () => {
  const { api } = useApi();
  const { isSignedIn } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isSignedIn) return;

    const getCurrentUser = async () => {
      const user = await api.user.getCurrentUser();

      // eslint-disable-next-line no-console
      console.log("User:", user);
    };

    getCurrentUser();
  }, [isSignedIn, api]);

  return (
    <>
      <SignedOut>
        <StyledAuthButtons>
          <StyledLoginButton>{t("common.login")}</StyledLoginButton>
          <StyledSignUpButton>{t("common.signUp")}</StyledSignUpButton>
        </StyledAuthButtons>
      </SignedOut>
      <SignedIn>
        <UserButton />
      </SignedIn>
    </>
  );
};

export default AuthContainer;
